import { http } from '../utils/http'

const searchApproveAction = (params) => {
  const url = '/api/v1/service/permission/findPage'
  return http.post(url, params)
};
const agreeAction = (params) => {
  const url = '/api/v1/service/permission/approve'
  return http.post(url, params)
};
const refuseAction = (id) => {
  const url = `/api/v1/roles/${id}/get`
  return http.post(url)
};
export default {
  searchApproveAction,
  agreeAction,
  refuseAction,
}
